export default __webpack_public_path__ + "media/images/icons/trending-up-71889a44da95437e10185ea4b98f7039.svg";